import { forwardRef, Ref } from 'react';

interface DefaultIconProps {
  color?: string;
  className?: string;
}

export const DefaultIcon = forwardRef(
  ({ color = '#EA40B9', className }: DefaultIconProps, ref: Ref<any>) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        className={className}
      >
        <title>Default Icon</title>
        <path
          d="M7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12ZM12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1Z"
          fill={color}
          stroke="white"
          strokeWidth="2"
        />
      </svg>
    );
  },
);
